import React from 'react';
import { Code } from 'lucide-react';

const APIDashboard = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <Code className="w-10 h-10 text-cyan-400" />
            <h1 className="text-3xl font-bold text-slate-100">
              API Management
            </h1>
          </div>
          <p className="text-lg text-slate-400">
            Centralized API management and configuration dashboard
          </p>
        </div>

        {/* Welcome Card */}
        <div className="rounded-lg shadow-lg p-8 border bg-slate-800 border-slate-700">
          <h2 className="text-2xl font-semibold text-slate-100 mb-4">
            Welcome to API Management
          </h2>
          <p className="text-slate-400 mb-6">
            Use the sidebar to navigate between different API configurations and management tools.
          </p>
          <div className="border-t border-slate-700 pt-6">
            <h3 className="text-lg font-medium text-slate-200 mb-3">
              Available APIs
            </h3>
            <ul className="space-y-2 text-slate-400">
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-cyan-500"></span>
                <span>Snowflake Kiva API - Integration and configuration tools</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-green-500"></span>
                <span>Location Inventory Query - CSV file processing from SAMBA share</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                <span>Order Cycle Time Report - CSV processing (API not implemented)</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-purple-500"></span>
                <span>Order Details Query - CSV processing (API not implemented)</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-indigo-500"></span>
                <span>Order Query - CSV processing (API not implemented)</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-orange-500"></span>
                <span>Picking Report - CSV processing (API not implemented)</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-pink-500"></span>
                <span>Sales Order Report - CSV processing (API not implemented)</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-teal-500"></span>
                <span>SKU Master View - CSV processing (API not implemented)</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-yellow-500"></span>
                <span>View Receipt Detail - CSV processing (API not implemented)</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APIDashboard;